import { Component, inject, input } from "@angular/core";
import { DialogAdapter } from "common/dialog/dialog-adapter";
import { UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule } from "@angular/forms";
import { CheckboxInput } from "common/form/input/types/checkbox-input";
import { Button } from "common/data/data-view.component";
import { MaintenanceService } from "common/maintenance/maintenance.service";
import { PopupHeaderComponent } from "common/popup/popup-header.component";
import { TranslateModule } from "@ngx-translate/core";
import { FocusErrorDirective } from "common/form/focus-error.directive";
import { InputComponent } from "common/form/input/input.component";
import { PopupFooterComponent } from "common/popup/popup-footer.component";
import MaintenancePushNotification = stages.core.maintenance.MaintenancePushNotification;

export interface Result {
	remindMe: boolean;
}

@Component({
	selector: "stages-confirm-maintenance",
	templateUrl: "./confirm-maintenance.component.html",
	imports: [
		PopupHeaderComponent,
		TranslateModule,
		ReactiveFormsModule,
		FocusErrorDirective,
		InputComponent,
		PopupFooterComponent,
	],
})
export class ConfirmMaintenanceComponent {
	private dialog = inject(DialogAdapter);
	private maintenanceService = inject(MaintenanceService);

	form = new UntypedFormGroup({});

	readonly titleKey = input.required<string>();

	readonly messageKey = input.required<string>();

	readonly maintenanceInfo = input.required<MaintenancePushNotification>();

	doNotShowAgainInput: CheckboxInput;

	buttons: Button[] = [];

	constructor() {
		const formBuilder = inject(UntypedFormBuilder);

		this.doNotShowAgainInput = new CheckboxInput({
			key: "doNotShowAgain",
			required: false,
			translateKey: "administration.maintenance.pushNotification.doNotShowAgain",
			value: false,
		});

		this.form.addControl(
			this.doNotShowAgainInput.key,
			formBuilder.control(this.doNotShowAgainInput.value, this.doNotShowAgainInput.validators),
		);

		this.buttons = [
			{
				class: "button sm",
				translate: "administration.maintenance.pushNotification.confirm",
				click: () => {
					this.confirm();
				},
				visible: () => true,
				disabled: () => {
					return false;
				},
			},
		];
	}

	confirm(): void {
		this.dialog.close({ action: "confirm", doNotShowAgain: this.form.controls.doNotShowAgain.value });
	}

	formatDate(date: string | null): string {
		return this.maintenanceService.formatDate(date);
	}
}
